import {i18n} from '@/plugins/i18n';
import {
    walletErrorStatusStr,
    walletErrorStatusVariant, walletErrorTypesStr,
    walletErrorTypesVariant
} from "@/constants/walletErrorsVariants";
import {companiesStr, companiesVariant} from "@/constants/companies";
import ArrayTableFieldModal from "@/components/table-elements/array-table-field-modal.vue";

export const arrayTableFieldTemplate = (field, type, icon_class, index, tab_index) => {
    let template = new ArrayTableFieldModal({
        props: {
            field,
            type,
            icon_class,
            index,
            tab_index
        },
        i18n,
    });

    template.field = field;
    template.index = index;
    template.type = type;
    template.icon_class = icon_class;
    template.tab_index = tab_index;
    return template.$mount().$el;
}

export default [
    {
        field: 'id',
        width: 40,
        title: i18n.t('label.wallet_errors_columns.id'),
        textAlign: 'center',
    },
    {
        field: 'status',
        title: i18n.t('label.wallet_errors_columns.status'),
        template: row => {
            return `
                <span class="badge badge-${walletErrorStatusVariant(row.status)}">
                    ${walletErrorStatusStr.get(row.status)}
                </span>
            `;
        },
        textAlign: 'center',
    },
    {
        field: 'type',
        title: i18n.t('label.wallet_errors_columns.type'),
        sortable: false,
        template: row => {
            return `
                <span class="badge badge-${walletErrorTypesVariant(row.type)}">
                    ${walletErrorTypesStr.get(row.type)}
                </span>
            `;
        },
        textAlign: 'center',
    },
    {
        field: 'account_number',
        title: i18n.t('label.wallet_errors_columns.account_number'),
        template: row => {
            return `
                <span class="">
                    ${row.wallet_bank_account.number}
                </span>
            `;
        },
        textAlign: 'center',
    },
    {
        field: 'wallet_transaction_id',
        title: i18n.t('label.wallet_errors_columns.wallet_transaction_id'),
        textAlign: 'center',
    },
    {
        field: 'duration',
        width: 50,
        title: i18n.t('label.wallet_errors_columns.duration'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'bank_name_fa',
        width: 50,
        title: i18n.t('label.wallet_errors_columns.bank_name'),
        textAlign: 'center',
    },
    {
        field: 'company',
        title: i18n.t('label.wallet_errors_columns.company'),
        sortable: false,
        width: 50,
        template: row => {
            return `
                <span class="badge badge-${companiesVariant(row.wallet_bank_account.company_id)}">
                    ${companiesStr.get(row.wallet_bank_account.company_id)}
                </span>
            `;
        },
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('label.wallet_errors_columns.created_at'),
        textAlign: 'center',
    },
    {
        field: 'reason',
        title: i18n.t('label.wallet_errors_columns.reason_title'),
        textAlign: 'center',
    },
    {
        field: 'request',
        title: i18n.t('label.wallet_errors_columns.request'),
        sortable: false,
        width: 50,
        template: (row, index) => {
            return arrayTableFieldTemplate(row.request, 'request', 'fa-info', index, -1)
        },
        textAlign: 'center',
    },
    {
        field: 'response',
        title: i18n.t('label.wallet_errors_columns.response'),
        sortable: false,
        width: 50,
        template: (row, index) => {
            return arrayTableFieldTemplate(row.response, 'response', 'fa-eye', index, -2)
        },
        textAlign: 'center',
    },
]
